import { AppDispatch, createAction } from '@reduxjs/toolkit';
import { TableFilter } from 'redux/reducers/teams';

export const CHANGE_TEAM_FILTERS = createAction<TableFilter[], string>('teams/CHANGE_TEAM_FILTERS');

export const changeTeamFilters = (employeesFilter: TableFilter[]) => (dispatch: AppDispatch) => {
  dispatch(CHANGE_TEAM_FILTERS(employeesFilter));
};
